import { S3_URL } from 'constants';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import React, { useEffect, useState } from 'react';
import { Button, Image } from 'react-bootstrap';
import { useShareMutation } from 'services';
import useCommonStore from 'store/common';

const ShareList: React.FC<any> = ({
	data: {
		isShared,
		name = '',
		userId = 0,
		profilePicture = '',
		userType = 'seeker',
		description = '',
		seekerCompanyName = '',
	},
	index = 0,
}) => {
	const { translate } = useTranslate();
	const { modalConfig = {} }: any = useCommonStore((state) => state);
	const { mutateAsync: shareUserMutation } = useShareMutation();
	const [shared, setShared] = useState<number>(isShared);

	const handleShare = () => {
		shareUserMutation({ postId: modalConfig?.id, userId });
	};

	useEffect(() => {
		setShared(isShared);
	}, [isShared]);

	return (
		<div
			key={`posts-${name}-${index}-${userId}`}
			className="users-detail d-flex  align-items-center gap-2"
		>
			<div className="d-flex align-items-center gap-2 gap-xl-3 flex-1">
				<div className="users-detail-profile rounded-circle">
					<Image
						src={`${S3_URL}${profilePicture}`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null;
							currentTarget.src = IMAGE_PATHS.UserDefault;
						}}
						className="w-100 h-100 object-fit-cover rounded-circle"
						loading="lazy"
					/>
				</div>
				<div className="users-detail-info flex-1">
					<h6 className="fw-bold mb-1">{name}</h6>
					<p className="mb-0">
						{userType === 'company'
							? description
							: ([description, seekerCompanyName].filter(Boolean).join(' at ') ?? '')}
					</p>
				</div>
			</div>
			<Button
				disabled={shared === 1}
				onClick={() => {
					setShared((prev) => (prev === 0 ? 1 : 0));
					handleShare();
				}}
				className={`${shared === 0 ? 'filled-btn' : 'transparent-btn'} rounded-pill lh-1`}
			>{`${shared === 0 ? translate('Button.share') : translate('Button.shared')}`}</Button>
		</div>
	);
};

export default ShareList;
